export const SEGMENTS_TO_HIDE_PERSONAL_WORKSPACE_NUDGE = ["/wallet/create"];

export const PersonalWorkspaceNudgeVariant = {
  WEB: "web",
  RESPONSIVE: "responsive",
};
